(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-header"]) return;
  try {
    
  if (!customElements.get('am-header')) {
    customElements.define(
      'am-header',
      class extends HTMLElement {
        connectedCallback() {
          // Keep Horizon's header height variables right for drawers, overlays and sticky offsets.
          const group = document.getElementById('header-group');
          this.setHeights = () => {
            document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
            document.body.style.setProperty('--header-group-height', `${(group || this).offsetHeight}px`);
          };
          this.setHeights();
          this.observer = new ResizeObserver(this.setHeights);
          this.observer.observe(this);

          const drawer = this.querySelector('[data-am-drawer]');
          const opener = this.querySelector('[data-am-open]');
          if (!drawer || !opener) return;
          opener.addEventListener('click', () => {
            drawer.showModal();
            opener.setAttribute('aria-expanded', 'true');
          });
          this.querySelector('[data-am-close]')?.addEventListener('click', () => drawer.close());
          drawer.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'));
          drawer.addEventListener('click', (e) => {
            if (e.target === drawer) drawer.close();
          });
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
